import { render, staticRenderFns } from "./Bestaetigung.vue?vue&type=template&id=0e76c0ac"
import script from "./Bestaetigung.vue?vue&type=script&lang=js"
export * from "./Bestaetigung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports